<div class="section">
  <app-checkout-header [title]="title()" [description]="description()" [action]="action()" [actionLabel]="actionLabel()" (actionEvent)="actionClick()" />
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>